import Layout from '@/views/Layout';

// 权限管理
/**
 * !!! 注意
 * 【route name】将用于菜单权限配置相关, 所以不要轻易改动name;
 * 如必要修改，请同步更新role相关菜单配置，以及通知服务端做相关更新（如有）；
 */

export default {
  name: 'AggregationManage',
  path: '/aggregation-manage',
  meta: {
    icon: 'el-icon-setting',
    label: '聚合管理',
    isMenu: true,
  },
  component: Layout,
  children: [
    {
      name: 'AggregationManageMy',
      path: 'my',
      component: () => import('@/views/AggregationManage/My'),
      meta: {
        label: '我的聚合',
        isMenu: true,
      },
    },
  ],
};
